export const state = () => ({
    filtersTouched: false,
    selectedFilters: {},
    uniqueSelectedFilters: [],
})

export const mutations = {
    updateFilter(state, { param, value, type }) {
        state.filtersTouched = true
        if (
            !state.selectedFilters[param] ||
            type === 'radio' ||
            type === 'range'
        ) {
            // filter doesn't exist yet or should be replaced ie. radio button
            mutations.setFilter(state, param, [value])

            if (param !== 'msrp_range' && param !== 'margin') {
                mutations.addToUniqueSelectedFilters(state, `${param}:${value}`)
            }
        } else {
            if (state.selectedFilters[param].includes(value)) {
                // if filter already in array remove it
                mutations.deleteFromExistingFilter(state, param, value)
                if (state.selectedFilters[param].length === 0) {
                    delete state.selectedFilters[param]
                    state.selectedFilters = { ...state.selectedFilters }
                }
                return
            }

            mutations.addToExistingFilter(state, param, value)
        }
    },
    setInitialFilters(state, payload) {
        state = { ...state, selectedFilters: {} }

        for (const key in payload) {
            if (typeof payload[key] === 'string' && key !== 'search') {
                // thanks Vue router
                mutations.setFilter(state, key, [payload[key]])
            } else {
                mutations.setFilter(state, key, payload[key])
            }
        }
    },
    addToExistingFilter(state, param, value) {
        const selectedFilters = { ...state.selectedFilters }
        selectedFilters[param].push(value)

        state = { ...state, selectedFilters }

        mutations.addToUniqueSelectedFilters(state, `${param}:${value}`)
    },
    deleteFromExistingFilter(state, param, value) {
        if (!state.selectedFilters[param]) return

        const index = state.selectedFilters[param].indexOf(value)
        const freshIndex = state.uniqueSelectedFilters.indexOf(
            `${param}:${value}`
        )
        if (index > -1) {
            const selectedFilters = { ...state.selectedFilters }
            selectedFilters[param].splice(index, 1)
            mutations.setFilter(state, param, selectedFilters[param])
        }
        if (freshIndex > -1) {
            state.uniqueSelectedFilters.splice(freshIndex, 1)
        }
    },
    setFilter(state, param, value) {
        // First delete the current
        delete state.selectedFilters[param]
        state.selectedFilters = { ...state.selectedFilters }

        // And then set the new value
        state.selectedFilters = { ...state.selectedFilters, [param]: value }
    },
    clearAllFilter(state, param) {
        mutations.clearUniqueSelectedFilters(state)

        state.selectedFilters = { ...state.selectedFilters, [param]: [] }

        state.filtersTouched = false
    },
    clearCustomFilter(state, array) {
        mutations.clearUniqueSelectedFilters(state)
        array.map((filter) => {
            mutations.deleteFromExistingFilter(
                state,
                filter.filterParam,
                filter.filterSlug
            )
        })
    },
    addToUniqueSelectedFilters(state, payload) {
        state.uniqueSelectedFilters.push(payload)
    },
    clearUniqueSelectedFilters(state) {
        state.uniqueSelectedFilters = []
    },
}
